module.exports = __webpack_public_path__ + "img/moto-azul.8cf27686.png";